import {
    TRIGGER_ENSIGHTEN_EVENT,
    MAX_EVENTS_TO_LOG
} from './EnsightenConstants';

export default (state = [], action) => {
    switch (action.type) {
        case TRIGGER_ENSIGHTEN_EVENT:
            return [action.payload, ...state].slice(0, MAX_EVENTS_TO_LOG);
        default:
            return state;
    }
};
